import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;

  ${(props) =>
    props.isActive
      ? css`
          display: block;
        `
      : css`
          display: none;
        `}
`;

export const Title = styled.div`
  background: #3498db;
  color: #fff;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 15px;
  font-weight: bold;
  padding: 0 0 0 15px;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 15px;
  margin-left: auto;

  &:after {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    background: #fff;
    background: url('/images/sp_layout.png') no-repeat -50px 0px;
    background-size: 350px 350px;
  }
`;

export const Wrapper = styled.div`
  min-height: calc(100% - 50px);
  height: calc(100% - 50px);
  overflow-y: scroll;
  width: 100%;
  background: #f1f2f4;
`;

export const List = styled.div`
  padding: 10px 0;
`;

export const MatchBox = styled.div`
  width: 100%;
  background: #fff;
  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export const MatchTab = styled.div`
  cursor: pointer;
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 12px;
  color: #222;

  &:before {
    content: '';
    display: block;
    width: 11px;
    height: 7px;
    margin: 0 15px;
    transform: translateY(-50%);
    right: 0;
    top: 50%;
    position: absolute;
    background: url('/images/sp_layout.png') no-repeat -225px -200px;
    background-size: 350px 350px;

    ${(props) =>
      props.isClose &&
      css`
        background-position: -225px -190px;
      `}
  }
`;

export const GamesWrapper = styled.div`
  width: 100%;
  display: none;
  ${(props) =>
    props.isActive &&
    css`
      display: block;
    `}
`;
